/* eslint-disable max-lines */
import { Params } from '@angular/router';

import { isNullOrUndefined } from '@app/util/util';
import { HotelFiltersPayload } from '@hotels/hotel-results/entities/hotel-filters.payload';
import { HotelSearchResponse } from '@hotels/hotel-results/entities/hotel-search.response';
import { HotelFilterTypes } from '@shared/hotel-itinerary/hotel-filters';
import { SorterTypes } from '@shared/filters/entities/sorter-options';
import { HotelFilterSearchPayload } from '@hotels/hotel-results/entities/hotel-filter-search.payload';
import { HotelFiltersPayloadState } from '@hotels/hotel-results/store/reducers/hotel-filters-payload.reducer';
import { PickedRange, FilterSorterCriterias } from '@shared/filters/entities/fetch-filters.response';
import { removeAmpersand } from '@app/pipes/mappers/parse-only-letterss.mapper';
import { TopZonesPayload } from '@app/entities/zones.response';
import { HotelFiltersResponse } from '@shared/magic-filter-bar/entities/filter-types';
import { DEFAULT_HOTEL_SORTER, STEP_HOTEL_RESULTS } from '@app/mappers/global-filters/hotel-global-filters.mapper';

export function pickedCheckboxes(payload: HotelFilterSearchPayload): string[] {
  if (Object.keys(payload).length > 0) {
    const defaultChekboxes = 
      [
        ...payload.Zones, 
        ...payload.Ammenities, 
        ...payload.Tags, 
        ...payload.Boards, 
        ...payload.CheckinTimes,
        ...payload.Score
      ];
    return !isNullOrUndefined(payload.RefundableType) ? [...defaultChekboxes, payload.RefundableType] : defaultChekboxes;
  } else return [];
}

export function pickedRanges(searchPayload: HotelFilterSearchPayload): PickedRange {
  return Object.keys(searchPayload).length === 0 ? {} as PickedRange :
    isNullOrUndefined(searchPayload.PriceFrom) && isNullOrUndefined(searchPayload.PriceTo) ? {} :
      {
        [HotelFilterTypes.Price]: [searchPayload.PriceFrom, searchPayload.PriceTo],
      };
}

export function pickedSorter(searchPayload: HotelFilterSearchPayload): FilterSorterCriterias {
  return {
    OrderDesc: searchPayload.OrderDesc || DEFAULT_HOTEL_SORTER.OrderDesc,
    OrderCriteria: searchPayload.OrderCriteria || DEFAULT_HOTEL_SORTER.OrderCriteria
  };
}

export function pickedStars(searchPayload: HotelFilterSearchPayload): string[] {
  return Object.keys(searchPayload).length === 0 ? [] : searchPayload.Categories || [];
}
export function mapHotelFilterForSearch(payload: HotelFiltersPayload, state: HotelFiltersPayloadState): HotelFilterSearchPayload {
  return {
    ...state,
    SearchId: payload.SearchId,
    SessionToken: payload.SessionToken
  };
}

export function mapSearchHotelFirstPaginate(response: HotelSearchResponse, token: string): HotelFilterSearchPayload {
  return {
    SearchId: response.SearchId,
    SessionToken: token,
    ResultCountLowerBound: 0,
    ResultCountUpperBound: STEP_HOTEL_RESULTS > response.ResultsCount ? response.ResultsCount : STEP_HOTEL_RESULTS,
    ResultsCount: response.ResultsCount,
    ResultsTotalCount: response.ResultsCount,
    Refresh: true,
    Ammenities: [],
    Boards: [],
    Categories: [],
    RefundableType: null,
    Zones: [],
    HotelName: '',
    CombineRooms: false,
    Tags: [],
    TotalDiscountPercentageFrom: 0,
    CheckinTimes: [],
    Score: []
  };
}

export function mapSearchHotelWithMarkers(payload: HotelFiltersPayloadState): HotelFilterSearchPayload {
  return {
    ...payload,
    ResultCountLowerBound: 0,
    ResultCountUpperBound: payload.ResultsCount,
    IncludeRooms: true
  };
}

export function mapHotelsWithFiltersExclusiveOfferPayload(
  payload: HotelFilterSearchPayload, isPrimeOrRappiCard: boolean): HotelFilterSearchPayload {
  return {
    ...payload,
    OrderCriteria: SorterTypes.DiscountPercentage as SorterTypes,
    MemberRatesOnly: isPrimeOrRappiCard,
    TotalDiscountPercentageFrom: 0.01,
    OrderDesc: true
  } as HotelFilterSearchPayload;
}

export function mapHotelsWithFiltersPayload(payload: HotelFilterSearchPayload): HotelFilterSearchPayload {
  return Object.keys(payload)
    .filter(item => item !== 'Refresh' && item !== 'ResultsCount')
    .map(key => key === 'HotelName' ? { [key]: removeAmpersand(payload[key]) } : { [key]: payload[key] })
    .reduce((beforeValue, value) => ({ ...beforeValue, ...value }), {}) as HotelFilterSearchPayload;
}

export function mapHotelFiltersToZonesPayload(cityCode: string, results: HotelFiltersResponse): TopZonesPayload {
  const zoneList = results.Zones.map(x => x.Text);
  return {
    Names: zoneList,
    CityCode: cityCode
  } as TopZonesPayload;
}

export function quaryFilterParams(queries: Params, params: string): string[] {
  return queries?.[params] ? queries?.[params].split(',').map(param => param.trim()) : [];
}

export function mapFiltersSearchHotels(filters: HotelFiltersResponse, resultsCounts: number): HotelFiltersResponse {
  const arrayProperties = Object.entries(filters);
  const filtersReduce = arrayProperties.map(x => {
    if (Array.isArray(x[1]) && x[1]?.length === 1 && x[1][0]['Count'] === resultsCounts) {
      return [x[0], []];
    }
    return x;
  })
  return resultsCounts ? { ...Object.fromEntries(filtersReduce) } as HotelFiltersResponse : filters;
}
